import { createReactRouterBasedAdapter } from './chunk-AAU4ZYLC.js';
import { useSearchParams, useNavigate } from 'react-router-dom';

var { NuqsAdapter, useOptimisticSearchParams } = createReactRouterBasedAdapter({
  adapter: "react-router-v6",
  useNavigate,
  useSearchParams
});

export { NuqsAdapter, useOptimisticSearchParams };
